// Origin for the backend API. Empty string means same-origin (Netlify functions).
// Set REACT_APP_API_BASE=https://outpost-api.splitfin.uk to use the VPS.
export const API_ORIGIN = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');

export const functionsUrl = (name: string): string => `${API_ORIGIN}/.netlify/functions/${name}`;
export const apiUrl = (path: string): string => `${API_ORIGIN}/api/${path.replace(/^\/+/, '')}`;
